import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import Swal from 'sweetalert2';
import CustomLoader from '../../../common/CustomLoader';
import { convertArrayToString } from './workflow-util';
import showAlert from '../../../../common/utils/alert';

export default class WorkflowDetail extends Component {
  static propTypes = {
    projectId: PropTypes.string.isRequired,
    collection: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  handleDelete = (workflowId) => {
    const { projectId, collection, version, actions } = this.props;
    const { uuid } = collection;
    const preConfirm = () => {
      actions.deleteCollectionWorkflow({
        workflowId,
        version,
        projectId,
        collectionUuid: uuid,
      });
    };
    showAlert("You won't be able to revert this.", preConfirm, 'Yes, delete it!');
  };

  render() {
    const { workflow, showWorkflowDeleteLoader } = this.props;
    const { workflowRules } = workflow;
    return (
      <Fragment>
        <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 drapcode">
          <h4>
            <strong>Name:</strong> {workflow.name}
          </h4>
          <h4>
            <strong>Field:</strong> {workflow.keyField.label}
          </h4>
          <br />
          <div className="card">
            <div className="card-header card-header-text" data-background-color="drapcode-violet">
              <h6 className="card-title pb-0 mb-0 text-capitalise">{workflow.name}: Rules</h6>
            </div>
            <div className="card-content">
              <div className="row mx-auto">
                <div className="table-responsive">
                  <table className="table table-grey table-bordered connector-list">
                    <thead>
                      <tr>
                        <th>Index</th>
                        <th>Access Level</th>
                        <th>Current Value</th>
                        <th>Next Value(s)</th>
                      </tr>
                    </thead>
                    <tbody>
                      {workflowRules && workflowRules.length > 0
                        ? workflowRules.map((wfr) => (
                            <tr key={wfr.id}>
                              <td>{wfr.id}</td>
                              <td>{wfr.role ? wfr.role.label : 'Anyone'}</td>
                              <td>{wfr.currentValue ? wfr.currentValue.label : ''}</td>
                              <td>{convertArrayToString(wfr.nextValue, 'label')}</td>
                            </tr>
                          ))
                        : ''}
                    </tbody>
                  </table>
                </div>
                <div className="col-12 text-right my-2 px-0">
                  <button
                    type="button"
                    className="btn btn-sm btn-theme-delete"
                    onClick={() => this.handleDelete(workflow.uuid)}
                    disabled={showWorkflowDeleteLoader}
                  >
                    <i className="wb webconnect-trash-regular"></i> Delete&nbsp;
                    <CustomLoader loading={showWorkflowDeleteLoader} />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}
